// Auto-generado por @xone-web/staticweb.
// Concatenación de los JS includes del proyecto (orden importa).
// @ts-nocheck — el contenido es JS XOne sin anotaciones de tipo.

// ===== funciones.js =====
// ===== vbscriptsupport.js =====
function doLogin(user, pass, collName) {
    appData.login({
        userName: user,
        password: pass,
        entryPoint: collName,
        onLoginSuccessful: function() {
            appData.getCurrentEnterprise().setVariables("LOGGED_USER", user);
        },
        onLoginFailed: function() {
            ui.msgBox("Error de acceso", "Usuario o contrasena incorrectos.", 0);
        }
    });
}

function ejecutarLogin(self) {
    var input = self.MAP_USUARIO ? self.MAP_USUARIO.toString().trim() : "";
    var pwd   = self.MAP_PASSWORD ? self.MAP_PASSWORD.toString().trim() : "";

    if (!input || input === "") {
        ui.msgBox("Error", "El usuario no puede estar vacio.", 0);
        return;
    }
    if (!pwd || pwd === "") {
        ui.msgBox("Error", "La contrasena no puede estar vacia.", 0);
        return;
    }

    // Acceso directo temporal
    if (input.toLowerCase() === "gestor" && pwd.toLowerCase() === "aprosuba") {
        appData.getCurrentEnterprise().setVariables("LOGGED_USER", "gestor");
        ui.openMenu("EntradaApp");
        return;
    }

    doLogin(input, pwd, "EntradaApp");
}

function toggleSubCD(self) {
    var visible = self.getFieldPropertyValue("BTN_CD_AGENDA", "visible");
    var mostrar = (visible === "0" || visible === 0) ? "7" : "0";
    self.setFieldPropertyValue("BTN_CD_USUARIOS",   "visible", mostrar);
    self.setFieldPropertyValue("BTN_CD_TRABAJADORES","visible", mostrar);
    self.setFieldPropertyValue("BTN_CD_AGENDA",      "visible", mostrar);
    self.setFieldPropertyValue("BTN_CD_LIBRO",       "visible", mostrar);
    self.setFieldPropertyValue("BTN_CD_ASISTENCIA",  "visible", mostrar);
    self.setFieldPropertyValue("BTN_CD_TRANSPORTE",  "visible", mostrar);
    var titulo = (mostrar === "7") ? "  Centro de Dia  ^" : "  Centro de Dia  v";
    self.setFieldPropertyValue("BTN_CD", "title", titulo);
}

async function irModulo(collName) {
    var coll = appData.getCollection(collName);
    if (!coll) {
        ui.showToast("Modulo no disponible: " + collName);
        return;
    }
    var obj = await coll.createObject();
    appData.pushValue(obj);
}

async function irServicio(bit) {
    // De momento solo Centro de Dia implementado
    if (bit === 1) {
        await irModulo("Agenda");
    } else {
        ui.showToast("Servicio en desarrollo");
    }
}

async function planilla_generarCalendario(self) {
    var mes  = parseInt(self.MAP_MES_ACTUAL)  || (new Date().getMonth() + 1);
    var anio = parseInt(self.MAP_ANIO_ACTUAL) || new Date().getFullYear();
    var meses = ["Enero","Febrero","Marzo","Abril","Mayo","Junio",
                 "Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
    self.setFieldPropertyValue("MAP_LBL_MES", "title", meses[mes-1] + " " + anio);

    var fltSrv  = parseInt(self.MAP_FLT_SERVICIO)  || 0;
    var fltUsr  = parseInt(self.MAP_FLT_IDUSUARIO) || 0;

    var cTurnos = self.getContents("TurnosMes");
    cTurnos.setMacro("##MAP_MES##",  mes.toString());
    cTurnos.setMacro("##ANIO##",     anio.toString());
    cTurnos.setMacro("##FLT_SRV##",  fltSrv.toString());
    cTurnos.setMacro("##FLT_USR##",  fltUsr.toString());
    cTurnos.unlock();
    cTurnos.clear();
    await cTurnos.loadAll();
    cTurnos.lock();

    var eventos = [];
    for (var i = 0; i < cTurnos.count(); i++) {
        var t = cTurnos.get(i);
        var tipo = parseInt(t.TIPO) || 1;
        var color = tipo === 1 ? "#378ADD" : tipo === 2 ? "#EF9F27" : "#7F77DD";
        var bgColor = tipo === 1 ? "#E6F1FB" : tipo === 2 ? "#FAEEDA" : "#EEEDFE";
        var fecha = t.FECHA ? t.FECHA.toString().substring(0,10) : "";
        eventos.push({
            fecha:  fecha,
            nombre: (t.MAP_NOMBRE_TRAB || "").toString(),
            hora:   (t.HORA_INI || "").toString().substring(0,5),
            color:  color,
            bgColor: bgColor,
            tipo:   tipo
        });
    }

    self.MAP_CAL_WEB = planilla_buildCalHTML(anio, mes, eventos);
    ui.getView(self).refresh("MAP_CAL_WEB");
}

function planilla_buildCalHTML(anio, mes, eventos) {
    var hoy = new Date();
    var hoyStr = hoy.getFullYear() + "-" +
        ("0"+(hoy.getMonth()+1)).slice(-2) + "-" +
        ("0"+hoy.getDate()).slice(-2);

    var primero = new Date(anio, mes-1, 1);
    var ultimoDia = new Date(anio, mes, 0).getDate();
    var diaSemana = primero.getDay();
    diaSemana = diaSemana === 0 ? 6 : diaSemana - 1;

    var prevMes = new Date(anio, mes-1, 0).getDate();

    var O = "<"; var C = ">";
    var css =
        "* { box-sizing: border-box; margin: 0; padding: 0; font-family: Arial, sans-serif; }" +
        "body { background: #fff; }" +
        ".grid { display: grid; grid-template-columns: repeat(7, 1fr); border-left: 1px solid #e8e8e8; border-top: 1px solid #e8e8e8; }" +
        ".day { border-right: 1px solid #e8e8e8; border-bottom: 1px solid #e8e8e8; min-height: 90px; padding: 4px; }" +
        ".day.otro { background: #fafafa; }" +
        ".day.hoy { background: #fdf0f6; }" +
        ".daynum { font-size: 11px; color: #888; margin-bottom: 3px; font-weight: 500; }" +
        ".daynum.hoy-num { background: #bb4e86; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-size: 10px; }" +
        ".ev { font-size: 9px; padding: 2px 4px; border-radius: 3px; margin-bottom: 2px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; cursor: pointer; }" +
        ".ev:hover { opacity: 0.8; }";

    var html = O + "html" + C + O + "head" + C +
        O + "meta charset='utf-8'/" + C +
        O + "style" + C + css + O + "/style" + C +
        O + "/head" + C + O + "body" + C +
        O + "div class='grid'" + C;

    var dia = 1;
    var totalCeldas = Math.ceil((diaSemana + ultimoDia) / 7) * 7;

    for (var i = 0; i < totalCeldas; i++) {
        var esOtroMes = (i < diaSemana || dia > ultimoDia);
        var numDia = esOtroMes ?
            (i < diaSemana ? prevMes - diaSemana + i + 1 : dia - ultimoDia) :
            dia;

        var fechaStr = "";
        if (!esOtroMes) {
            fechaStr = anio + "-" +
                ("0"+mes).slice(-2) + "-" +
                ("0"+numDia).slice(-2);
        }

        var esHoy = (fechaStr === hoyStr);
        var claseDay = "day" + (esOtroMes ? " otro" : "") + (esHoy ? " hoy" : "");

        html += O + "div class='" + claseDay + "'" + C;
        var claseNum = "daynum" + (esHoy ? " hoy-num" : "");
        html += O + "div class='" + claseNum + "'" + C + numDia + O + "/div" + C;

        if (!esOtroMes && fechaStr !== "") {
            for (var j = 0; j < eventos.length; j++) {
                var ev = eventos[j];
                if (ev.fecha === fechaStr) {
                    html += O + "div class='ev' style='background:" + ev.bgColor +
                        ";color:" + ev.color + "'" + C +
                        ev.hora + " " + ev.nombre +
                        O + "/div" + C;
                }
            }
        }

        html += O + "/div" + C;
        if (!esOtroMes) dia++;
    }

    html += O + "/div" + C + O + "/body" + C + O + "/html" + C;
    return html;
}

async function planilla_cambiarMes(self, dir) {
    var mes  = parseInt(self.MAP_MES_ACTUAL)  || (new Date().getMonth() + 1);
    var anio = parseInt(self.MAP_ANIO_ACTUAL) || new Date().getFullYear();
    mes += dir;
    if (mes > 12) { mes = 1;  anio++; }
    if (mes < 1)  { mes = 12; anio--; }
    self.MAP_MES_ACTUAL  = mes;
    self.MAP_ANIO_ACTUAL = anio;
    await planilla_generarCalendario(self);
}

async function planilla_filtrarServicio(self, bit) {
    var padre = ui.getView(self).getDataObject();
    padre.MAP_FLT_SERVICIO = bit;
    var chips = ["BTN_FLT_TODOS","BTN_FLT_CD","BTN_FLT_CO","BTN_FLT_RAL","BTN_FLT_VT","BTN_FLT_AT","BTN_FLT_HF"];
    var bits  = [0, 1, 2, 4, 16, 32, 64];
    for (var i = 0; i < chips.length; i++) {
        padre.setFieldPropertyValue(chips[i], "class", bits[i] === bit ? "planillaChipActivo" : "planillaChip");
    }
    await planilla_generarCalendario(padre);
}

async function planilla_filtrarTrabajador(self) {
    var padre = ui.getView(self).getDataObject();
    padre.MAP_FLT_IDUSUARIO = parseInt(self.MAP_FLT_TRABAJADOR) || 0;
    await planilla_generarCalendario(padre);
}

function planilla_setTab(self, tab) {
    var padre = ui.getView(self).getDataObject();
    var tabs = ["BTN_TAB_CAL","BTN_TAB_MIS","BTN_TAB_CAM","BTN_TAB_PET"];
    for (var i = 0; i < tabs.length; i++) {
        padre.setFieldPropertyValue(tabs[i], "class", (i+1) === tab ? "planillaTabActivo" : "planillaTab");
    }
    padre.MAP_VISTA = tab;
    ui.getView(padre).refresh();
}

async function pi_setTab(self, tab) {
    var padre = ui.getView(self).getDataObject();
    padre.MAP_TAB_ACTUAL = tab;
    padre.setFieldPropertyValue("BTN_TAB_INC", "class", tab === 1 ? "piTabActivo" : "piTab");
    padre.setFieldPropertyValue("BTN_TAB_PED", "class", tab === 2 ? "piTabActivo" : "piTab");
    padre.setFieldPropertyValue("frmListaInc", "visible", tab === 1 ? "7" : "0");
    padre.setFieldPropertyValue("frmListaPed", "visible", tab === 2 ? "7" : "0");
    padre.setFieldPropertyValue("BTN_NUEVO", "title", tab === 1 ? "+ Nueva incidencia" : "+ Nuevo pedido");
    await pi_cargarLista(padre);
}

async function pi_cargarLista(self) {
    var srv = (self.MAP_FLT_SERVICIO || 0).toString();
    var est = (self.MAP_FLT_ESTADO  || 0).toString();
    var tab = parseInt(self.MAP_TAB_ACTUAL) || 1;

    if (tab === 1) {
        var cInc = self.getContents("cntIncidencias");
        cInc.setMacro("##FLT_SRV##", srv);
        cInc.setMacro("##FLT_EST##", est);
        cInc.unlock();
        cInc.clear();
        await cInc.loadAll();
        cInc.lock();
    } else {
        var cPed = self.getContents("cntPedidos");
        cPed.setMacro("##FLT_SRV##", srv);
        cPed.setMacro("##FLT_EST##", est);
        cPed.unlock();
        cPed.clear();
        await cPed.loadAll();
        cPed.lock();
    }
    ui.getView(self).refresh();
}

async function pi_filtrarServicio(self, bit) {
    var padre = ui.getView(self).getDataObject();
    padre.MAP_FLT_SERVICIO = bit;
    var chips = ["BTN_SRV_0","BTN_SRV_1","BTN_SRV_2","BTN_SRV_4","BTN_SRV_16","BTN_SRV_32"];
    var bits  = [0, 1, 2, 4, 16, 32];
    for (var i = 0; i < chips.length; i++) {
        padre.setFieldPropertyValue(chips[i], "class", bits[i] === bit ? "piChipActivo" : "piChip");
    }
    await pi_cargarLista(padre);
}

async function pi_filtrarEstado(self, estado) {
    var padre = ui.getView(self).getDataObject();
    padre.MAP_FLT_ESTADO = estado;
    var chips = ["BTN_EST_0","BTN_EST_1","BTN_EST_2","BTN_EST_3"];
    var ests  = [0, 1, 2, 3];
    for (var i = 0; i < chips.length; i++) {
        padre.setFieldPropertyValue(chips[i], "class", ests[i] === estado ? "piChipActivo" : "piChip");
    }
    await pi_cargarLista(padre);
}

async function pi_abrirNuevo(self) {
    var padre = ui.getView(self).getDataObject();
    var tab = parseInt(padre.MAP_TAB_ACTUAL) || 1;
    if (tab === 1) {
        await irModulo("NuevaIncidencia");
    } else {
        await irModulo("NuevoPedido");
    }
}

// vbscriptsupport.js - no utilizado en proyecto web

// ===== exports para MPA Island mode =====
export { doLogin, ejecutarLogin, toggleSubCD, irModulo, irServicio, planilla_generarCalendario, planilla_buildCalHTML, planilla_cambiarMes, planilla_filtrarServicio, planilla_filtrarTrabajador, planilla_setTab, pi_setTab, pi_cargarLista, pi_filtrarServicio, pi_filtrarEstado, pi_abrirNuevo };
